import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _wrapNativeSuper from "@babel/runtime/helpers/esm/wrapNativeSuper";
import resolveUrl from './utils/resolve-url';

let ResponseError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(ResponseError, _Error);

  function ResponseError(message, response) {
    var _this;

    _this = _Error.call(this, message) || this;
    Object.setPrototypeOf(_assertThisInitialized(_this), ResponseError.prototype);
    _this.response = response;
    return _this;
  }

  return ResponseError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * @param {HttpResponse<T>} response
 * @throws {ResponseError} if response code is not ok
 */


function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  const error = new ResponseError(response.statusText, response);
  throw error;
}
/**
 * @param {string} url
 * @param {HttpDataFetcher} fetcher
 * @param {Object} params
 */


export function fetchData(url, fetcher, params) {
  if (params === void 0) {
    params = {};
  }

  return fetcher(resolveUrl(url, params)).then(checkStatus).then(response => {
    // axios auto-parses JSON responses, don't need to JSON.parse
    return response.data;
  });
}